import { render, staticRenderFns } from "./ScoreChartCountries.vue?vue&type=template&id=13f28160"
import script from "./ScoreChartCountries.vue?vue&type=script&lang=js"
export * from "./ScoreChartCountries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports